import {
  STEP_INCREMENT,
  STEP_DECREMENT,
  STEP_DIRECT,
  MOBILE,
  EXP_CHANGE,
  ERROR_STATE
} from './types';
import { push } from "react-router-redux";

export const mobileCheck = () => {
  return dispatch => {
    dispatch({
      type: MOBILE
    })
  }
}

export const errorOpen = (title, message) => {
  return dispatch => {
    dispatch({
      type: ERROR_STATE,
      data: true,
      title: title,
      message: message
    });
  }
}

export const errorClose = () => {
  return dispatch => {
    dispatch({
      type: ERROR_STATE,
      data: false,
      title: '',
      message: ''
    })
  }
}

export const stepDirect = (step , path) => {
  return dispatch => {
    dispatch( push(path) )
    dispatch({
      type: STEP_DIRECT,
      data: step
    })
  }
}

export const stepIncrement = () => {
  return dispatch => {
    dispatch({
      type: STEP_INCREMENT
    })
  }
}

export const stepDecrement = () => {
  return dispatch => {
    dispatch({
      type: STEP_DECREMENT
    })
  }
}

export const expChange = (value) => {
  return dispatch => {
    dispatch({
      type: EXP_CHANGE,
      data: value
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/step.js